module.exports = __webpack_public_path__ + "img/green-car-add.f86cfffc.svg";